import EditTransactionModal from './EditTransactionModal';

export default EditTransactionModal;
